import React, { useState, useEffect } from "react";
import Popup from "reactjs-popup";
import { getClubs } from "shared/services/api-assistant.js";
import ItemRowClub from "shared/components/items/ItemRowClub.js";
import LoadingSquare from "shared/components/loading/LoadingSquare.js";
import BoxMessage from "shared/components/box/BoxMessage.js";

interface PopupSelectClubProps {
  trigger: React.ReactNode;
  onClose?: () => void;
  onConfirm: (club: any) => void;
}

const PopupSelectClub: React.FC<PopupSelectClubProps> = ({
  trigger,
  onClose,
  onConfirm,
}) => {
  const [clubs, setClubs] = useState(null);
  const [selectedClub, setSelectedClub] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const fetchClubs = () => {
    setIsLoading(true);
    getClubs({
      handleSuccess: (d) => {
        setClubs(d.data.getClubs);
        setIsLoading(false);
      },
      handleError: (e) => console.log(e),
      params: {
        search: searchQuery,
      },
    });
  };

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
  };

  const handleSelect = (club) => {
    setSelectedClub(club);
  };

  const handleConfirm = (close) => {
    if (selectedClub && onConfirm) {
      onConfirm(selectedClub);
    }
    close();
  };

  return (
    <div className="PopupSearchClub">
      <Popup
        trigger={trigger}
        modal
        closeOnDocumentClick={false}
        onClose={onClose}
        className="fade-in popup-md"
      >
        {(close) => (
          <div>
            <div className="d-flex flex-row mb-3">
              <div className="flex-grow-1">
                <h2 className="text-white">Import from club</h2>
              </div>
              <div className="flex-grow-0">
                <button className="btn" onClick={close}>
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>
            </div>

            <div className="d-flex flex-row mb-3">
              <input
                type="text"
                className="form-control me-1"
                placeholder="Search by name..."
                value={searchQuery}
                onChange={handleSearch}
              />

              <button className="btn btn-info text-white" onClick={() => fetchClubs()} disabled={searchQuery.length < 2}>
                <i className="bi bi-search text-white"></i>
              </button>
            </div>

            <div className="d-flex flex-column mb-3 overflow-auto" style={{ maxHeight: "400px" }}>
              {!isLoading && clubs?.length > 0 &&
                clubs.map((club) => (
                  <ItemRowClub
                    key={club.id}
                    c={club}
                    isSelected={selectedClub && selectedClub.id === club.id}
                    selectable
                    onSelect={handleSelect}
                  />
                ))
              }

              {!isLoading && (clubs === null) && (
                <BoxMessage content="No search found" className="my-5"/>
              )}

              {!isLoading && (clubs?.length === 0) && (
                <BoxMessage content="No club found" className="my-5"/>
              )}

              {isLoading && 
                <div className="ratio ratio-16x9 w-100">
                  <LoadingSquare />
                </div>
              }
            </div>

            {/* Confirm Button */}
            <div className="d-flex justify-content-end mt-3">
              <button
                className="btn btn-info text-white"
                disabled={!selectedClub}
                onClick={() => handleConfirm(close)}
              >
                Import players
              </button>
            </div>
          </div>
        )}
      </Popup>
    </div>
  );
};

export default PopupSelectClub;